import { useAuthStore } from '@/stores/auth'

export default () => {
  const { isLogged } = useAuthStore()

  return isLogged ? { name: 'home' } : true
}
